const groupBy = <T,>(
	array: readonly T[] | null | undefined,
	key: (item: T) => string | number,
): Record<string, T[]> => {
	const result: Record<string, T[]> = {}
	if (!array) {
		return result
	}

	array.forEach((item) => {
		const k = String(key(item))
		const tempResult = (result[k] = result[k] || [])
		tempResult.push(item)
	})

	return result
}

export default groupBy
